import * as React from 'react'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'

import usePageLoaded from '../../hooks/usePageLoaded'

import Title from '../../components/ui/title/title'
import Button from '../../components/ui/button'
import PaymentTable from './PaymentTable'
import PaginationLoader from '../../components/ui/paginationLoader/PaginationLoader'

import { Helmet } from 'react-helmet'
import Pagination from 'rsuite/Pagination'
import { META } from '../../constants/meta'

import { checkAuth } from '../../utils/auth'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import { getLangFromPath, getPrefixFromPath } from '../../i18next'
import { fetchPaymentHistory } from '../../store/member/memberSlice'
import paths from '../../paths'
import './premiumHistory.sass'
import '../index/pagination.sass'

const PremiumHistory: React.FunctionComponent = () => {
    usePageLoaded()

    const [t] = useTranslation()
    const history = useHistory()
    const location = useLocation()
    const dispatch = useDispatch()

    const { loading, paymentHistory } = useSelector((state: RootState) => state.member)

    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        dispatch(fetchPaymentHistory({ p: currentPage }))
    }, [currentPage])

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.premiumHistory[getLangFromPath(location.pathname)].title}</title>
                <meta
                    name="description"
                    content={META.premiumHistory[getLangFromPath(location.pathname)].description}
                />
            </Helmet>
            <div className="premiumHistoryPageRow">
                <Title text={t('Premium')} />
                <Button
                    label={'Buy Premium Membership'}
                    onClick={() => history.push(createLocalizedPath('/membre/payment'))}
                />
            </div>
            {paymentHistory ? <PaymentTable list={paymentHistory.list} /> : <></>}
            <div className="premiumPaginationWrapper">
                {!loading && paymentHistory ? (
                    <Pagination
                        limit={20}
                        limitOptions={[10]}
                        maxButtons={5}
                        activePage={currentPage}
                        onChangePage={(page: number) => setCurrentPage(page)}
                        total={+paymentHistory.total_count}
                    />
                ) : (
                    <PaginationLoader />
                )}
            </div>
        </div>
    )
}

// @ts-ignore
PremiumHistory.getInitialProps = async ({ req, store }) => {
    await checkAuth(store)
    const {
        member: { loggedIn }
    } = store.getState()

    if (!loggedIn)
        return {
            redirectTo: `${getPrefixFromPath(req.url)}/login_required?returnPath=${paths.premiumHistory.path}`
        }
}

export default PremiumHistory
